import { motion } from "framer-motion";

const STATUS = {
  active: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  approved: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  paid: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  pending: "bg-amber-500/15 text-amber-400 border-amber-500/30",
  confirmed: "bg-sky-500/15 text-sky-400 border-sky-500/30",
  shipped: "bg-indigo-500/15 text-indigo-400 border-indigo-500/30",
  delivered: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  inactive: "bg-slate-500/15 text-slate-400 border-slate-500/30",
  rejected: "bg-red-500/15 text-red-400 border-red-500/30",
  deactivated: "bg-red-500/15 text-red-400 border-red-500/30",
};

export const StatusBadge = ({ status, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 font-mono text-[10px] uppercase tracking-widest ${STATUS[status] || STATUS.inactive}`}>
    <span className="h-1.5 w-1.5 rounded-full bg-current" />
    {status}
  </span>
);

export const Label = ({ children }) => (
  <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-amber-500">{children}</p>
);

export const Panel = ({ children, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y: 12 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.35 }}
    className={`rounded-2xl border border-[#1F293D] bg-[#111827] p-6 ${className}`}
    {...rest}
  >
    {children}
  </motion.div>
);

export const StatCard = ({ label, value, icon: Icon, accent = "text-emerald-400", testId, delay = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 12 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.35, delay }}
    data-testid={testId}
    className="group rounded-2xl border border-[#1F293D] bg-[#111827] p-5 transition-[transform,border-color] duration-200 hover:-translate-y-0.5 hover:border-emerald-500/40"
  >
    <div className="flex items-center justify-between">
      <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-slate-400">{label}</p>
      {Icon && <Icon className={`h-4 w-4 ${accent}`} />}
    </div>
    <p className="mt-4 font-display text-3xl font-extrabold tracking-tight text-white">{value}</p>
  </motion.div>
);

export const PageHead = ({ label, title, children }) => (
  <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <Label>{label}</Label>
      <h1 className="mt-2 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl">{title}</h1>
    </div>
    {children}
  </div>
);

export const Empty = ({ text, testId }) => (
  <div data-testid={testId} className="rounded-xl border border-dashed border-[#1F293D] p-10 text-center text-sm text-slate-500">{text}</div>
);
